import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useToggleButtonStyles = makeStyles<Theme, { fullWidthOnMobile?: boolean }>(() => ({
  root: {
    width: ({ fullWidthOnMobile }) => (fullWidthOnMobile ? '100%' : 'auto')
  },
  idle: {
    border: '1px solid transparent',
    '&:hover': {
      border: '1px solid transparent'
    }
  },
  label: {
    whiteSpace: 'nowrap'
  }
}));
